export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    height: 'calc(100vh - 80px)',
  },
};
